(function ($, visceral) {

    if (visceral == null) {
        window.visceral = visceral = {};
    }


    $(window).on('load', function () {
        init();
    });


    function init() {
        let grid = $('.resource-grid');
        if (!grid.length) {
            return;
        }

        // get all filter items
        let items = grid.find('.vc_grid-filter-item span');

        // find the item with the data attribute 'data-vc-grid-filter-value' value of '.vc_grid-term-25'
        let imagineItem = items.filter(function () {
            return $(this).data('vc-grid-filter-value') === '.vc_grid-term-25';
        });

        // on load, click the item to filter the grid
        imagineItem.click();


        remove_empty_images();
        setInterval(function () {
            remove_empty_images();
        }, 2000)
    }

    function remove_empty_images() {
        //loop over every row. if row doesnt have an image (or has a placeholder image), remove the image column
        $('.vc_grid-item:not(.processed-empty-images').each(function () {
            let item = $(this);
            remove_empty_image(item)
            item.addClass('processed-empty-images')
        });
    }

    function remove_empty_image(item) {
        console.log('checking', item);
        let image = item.find('img.vc_gitem-zone-img');

        if (image.length == 0 || ends_with(image.attr('src'), 'vc_gitem_image.png')) {
            console.log('missing image or has placeholder image');
            item.find('.vc_gitem-animated-block').remove();
        }
    }

    function ends_with(value, ending) {
        let re = RegExp(`${ending}$`, 'gi');
        console.log('value', value, 'regexp', re);
        return re.test(value);
    }



})(jQuery, window.visceral);


// WEBPACK FOOTER //
// ./scripts/resources.js